<template>
  <div class="bar1">
    <div v-if="alert" class="alert alert-danger mx-3 mb-3" role="alert">
      {{ alert }}
    </div>
    <div class="main-bar px-3 pb-3">
      <div class="pr-4">
        <date-pick
          v-model="from"
          :inputAttributes="{ id: 'datefrom', name: `date-from`, autocomplete: 'off' }"
          :format="'YYYY-MM-DD'"
          :displayFormat="format"
          :parseDate="parseDate"
          :formatDate="formatDate"
          :weekdays="weekdays"
          :months="months"
          :isDateDisabled="isBeforeTo"
          autocomplete="off">
            <template v-slot:default="{toggle, inputValue}">
                <input @click="toggle" class="form-control rounded" :value="inputValue ? inputValue : 'A partir du'">
            </template>
          </date-pick>
      </div>
      <div class="pr-4">
        <date-pick
          v-model="to"
          :inputAttributes="{ id: 'dateto', name: `date-to`, autocomplete: 'off' }"
          :format="'YYYY-MM-DD'"
          :displayFormat="format"
          :parseDate="parseDate"
          :formatDate="formatDate"
          :weekdays="weekdays"
          :months="months"
          :isDateDisabled="isBeforeFrom"
          autocomplete="off">
            <template v-slot:default="{toggle, inputValue}">
                <input @click="toggle" class="form-control rounded" :value="inputValue ? inputValue : 'Jusqu\'au'">
            </template>
          </date-pick>
      </div>
      <div class="pr-4">
        <div class="dropdown">
          <button class="btn btn-white dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-expanded="false">
            Status ({{ status.length }})
          </button>
          <form class="dropdown-menu p-4" style="min-width: 250px;">
            <div class="form-check" v-for="a in allStatus" :key="a.key">
              <input class="form-check-input" type="checkbox" :value="a.key" :id="a.key" v-model="status">
              <label class="form-check-label" :for="a.key">
                {{ a.name }}
              </label>
            </div>
          </form>
        </div>
      </div>
      <div>
        <button :disabled="loading" @click="submit" class="btn btn-primary" type="button">
          <span v-if="loading">Chargement...</span>
          <span v-else>Télécharger</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'
import fecha from 'fecha'
import moment from 'moment'
import axios from 'axios'

export default {
  components: { DatePick },

  props: {
    weekdays: {
      type: Array,
      default: () => ([
          'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'
      ])
    },
    months: {
      type: Array,
      default: () => ([
        'janvier', 'février', 'mars', 'avril',
        'mai', 'juin', 'juillet', 'août',
        'septembre', 'octobre', 'novembre', 'décembre'
      ])
    },
  },

  data() {
    return {
      loading: false,
      alert: '',
      format: 'DD MMMM YYYY',
      from: null,
      to: null,
      status: [],
      allStatus: [
        {
          key: 'invoice_received',
          name: 'Facture reçue'
        },
        {
          key: 'payment_done',
          name: 'Paiement effectué'
        },
      ],
    }
  },

  methods: {
    parseDate(dateString, format) {
        return fecha.parse(dateString, format);
    },
    formatDate(dateObj, format) {
        return fecha.format(dateObj, format);
    },
    isBeforeTo(date) {
        if (this.to) {
          if (moment(date).isAfter(moment(this.to))) {
            return true
          }
        }

        return moment(date).isAfter(moment())
    },
    isBeforeFrom(date) {
      if (this.from) {
        if (moment(date).isBefore(moment(this.from))) {
          return true
        }
      }

      return moment(date).isAfter(moment())
    },
    submit() {
      this.alert = ''

      if (this.loading) {
        return
      }

      if (!this.from || !this.to) {
        this.alert = 'Vous devez mettre une date de début et de fin.'
        return
      }

      if (this.status.length === 0) {
        this.alert = 'Vous devez mettre au moins un status.'
        return
      }

      this.loading = true

      axios.post('https://staging-lgm-data-uah2.encr.app/invoices', {
        from: this.from,
        to: this.to,
        status: this.status
      }, { responseType: 'blob' })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'factures-lgm.zip')
            document.body.appendChild(link)
            link.click()
        })
        .catch(() => {
          this.alert = 'Une erreur c\'est produite, merci de contacter un administrateur.'
        })
        .finally(() => {
          this.from = null
          this.to = null
          this.status = []
          this.loading = false
        })
    }
  },

  mounted() {
    fecha.i18n.monthNames = this.months
  },
}
</script>

<style>
  .bar1 {
    display: flex;
    flex-direction: column;
  }
  .main-bar {
    display: flex;
    align-items: center;
  }
</style>
